// 9fbef606107a605d69c0edbcd8029e5d 
const PLCC_OFFER_CONSTANTS = {
  PLCC_OFFER_MODAL_TOGGLE: 'PLCC_OFFER_MODAL_TOGGLE',
};

export default PLCC_OFFER_CONSTANTS;
